<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import { useMapGetter } from 'dashboard/composables/store';
import LaisGamificationSurface from 'dashboard/components-next/LaisGamificationSurface.vue';
import ImudeiFinanceDashboard from '../components/ImudeiFinanceDashboard.vue';
import ImudeiFinanceQuickView from '../components/ImudeiFinanceQuickView.vue';
import { useRealEstateFinance } from '../composables/useRealEstateFinance';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const currentUser = useMapGetter('getCurrentUser');
const finance = useRealEstateFinance({ notify: useAlert, t });
const selectedFinanceRow = ref(null);
const financeMission = {
  title: 'Conciliar lançamentos',
  description: 'Concilie 2 lançamentos e mantenha a auditoria em dia',
  points: 50,
  progress: 1,
  target: 2,
};
const openTransaction = row =>
  router.push({
    name: 'operacao_imobiliaria_financeiro_detalhes',
    params: {
      accountId: route.params.accountId,
      salesTransactionId: row.processo_id,
    },
  });
const openInstallment = (row, action) =>
  router.push({
    name: 'operacao_imobiliaria_financeiro_status',
    params: {
      accountId: route.params.accountId,
      salesTransactionId: row.processo_id,
      installmentId: row.parcela_id,
    },
    query: action ? { action } : undefined,
  });
</script>

<template>
  <LaisGamificationSurface
    :user-id="currentUser?.id"
    show-rail
    :show-bar-mission="false"
    :mission="financeMission"
    class="min-h-full bg-lais-bg-soft"
  >
    <ImudeiFinanceDashboard
      :rows="finance.rows.value"
      :loading="finance.loading.value"
      :selected-id="selectedFinanceRow?.id"
      @refresh="finance.load"
      @select="selectedFinanceRow = $event"
      @open-details="openTransaction"
      @open-status="openInstallment"
    />

    <template #rail>
      <ImudeiFinanceQuickView
        :row="selectedFinanceRow"
        @open-status="openInstallment"
      />
    </template>
  </LaisGamificationSurface>
</template>
